import { BaseModel } from "sjs-base-model";
import ValoriModel from "./ValoriModel";

export default class CommissionsDataModel extends BaseModel {
    public readonly idStrip: number = 0;
    public readonly commissioniCessionaria: ValoriModel = new ValoriModel({});
    public readonly commissioneCessionaria: number = 0;
    public readonly totaleCommissioniPassive: number = 0;
    public readonly extraprovvigione: ValoriModel = new ValoriModel({});
    public readonly commissioniBanca: ValoriModel = new ValoriModel({});
    public readonly commissioniAgente: ValoriModel = new ValoriModel({});
    public readonly provvigioniCommissioniTot: ValoriModel = new ValoriModel({});
    public readonly costiMediatori: ValoriModel = new ValoriModel({});
    public readonly commissioneBancaSegnalante: ValoriModel = new ValoriModel({});
    public readonly commissioniPassiveUpFront: ValoriModel = new ValoriModel({});
    public readonly commissioniPassiveRunning: ValoriModel = new ValoriModel({});
    public readonly commissioniPratica: number = 0;

    constructor(data: Partial<CommissionsDataModel>) {
        super();

        this.update(data);
    }
}
